import axios from "axios";
import { getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag";
import { clienteInfo } from "utils/DatosUsuarioLocalStorag";
import { getUsuario } from "utils/DatosUsuarioLocalStorag";
import { Host } from "utils/constantes";
import { boleteriaAxios } from "utils/index";


export const registraPagos = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : (getDatosUsuariosLocalStorag()?.id || 0)
    let parmspro = {
        ...parms,
        "id_usuario": parseInt(id || 0),
        "id_operador": parseInt(idop || 0),
        // Panel (admin / vendedor): un comprobante repetido queda en "Comprobar" para revision. El cliente desde
        // la pagina, en cambio, no puede volver a subir el mismo comprobante en otra compra suya (ver RegistrarPagos)
        "accion_admin": parms.accion_admin !== undefined ? Boolean(parms.accion_admin) : clienteInfo() != null
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/registraPagos", parmspro, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
            
        })
        if (parms.forma_pago === "Deposito") {
            const bancoSeleccionado = parms.bancos || parms.banco || "";
            if (bancoSeleccionado) {
                boleteriaAxios.post("Boleteria/bancos", {
                    "bancos": bancoSeleccionado,
                    "id": parms.id
                }).catch(function (error) {
                    console.warn("registraPagos.bancos.warn", {
                        id: parms.id,
                        banco: bancoSeleccionado,
                        status: error?.response?.status
                    });
                });
            }
        }
        return data
    } catch (error) {
        console.error("registraPagos.error", {
            status: error?.response?.status,
            data: error?.response?.data,
            payload: parmspro,
        })
        return error
    }
}

export const listarRegistropanel = async (parms) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/listarRegistros", parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const listarRegistroPorId = async (idRegistro) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/listarRegistros?id_registro=" + idRegistro + "&init=0&size=1", {
            "cedula": ""
        }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
                // Sesion del usuario: el backend filtra por SUS eventos asignados
                ...(getUsuario() ? { 'Authorization': `Bearer ${getUsuario()}` } : {})
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const ListarRegistropaneFecha = async (ini, fin) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/listarRegistros?fecha_init=" + ini + "&fecha_fin=" + fin + "&init=0&size=100",
            {
                "cedula": ""
            }
            , {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
                    // Sesion del usuario: el backend filtra por SUS eventos asignados
                    ...(getUsuario() ? { 'Authorization': `Bearer ${getUsuario()}` } : {})
                }
            })
        return data
    } catch (error) {
        return error
    }
}
// Reporte agregado de ventas por usuario (opcion B del analisis):
// el backend procesa TODO el rango sin paginar y devuelve los totales
// agrupados por operador que vendio y por autogestion (clientes que
// compraron solos). Ver ReporteVentasUsuario en MS-LOGIN-BOLETERIA.
export const ReporteVentasUsuario = async (fecha_init, fecha_fin, canal = "", detalle = false, codigoEvento = "") => {
    try {
        const qs = new URLSearchParams({
            fecha_init,
            fecha_fin,
            ...(canal ? { canal } : {}),
            ...(detalle ? { detalle: "1" } : {}),
            ...(codigoEvento ? { codigoEvento } : {})
        }).toString()
        let { data } = await axios.post(
            "https://api.t-ickets.com/ms_login/api/v1/reporte_ventas_usuario?" + qs,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
                    // Sesion del usuario: el backend filtra por SUS eventos asignados
                    ...(getUsuario() ? { 'Authorization': `Bearer ${getUsuario()}` } : {})
                }
            }
        )
        return data
    } catch (error) {
        return error
    }
}

// Auditoria de comprobantes de pago (solo perfil admin -- ver
// ListarComprobantesPago en RegistraCompra.controller.js). A diferencia del
// resto de este archivo, este endpoint SI valida el perfil en el backend,
// por eso manda el JWT real (Authorization: Bearer) ademas del Basic.
export const ListarComprobantesPago = async (fecha_init = "", fecha_fin = "", codigoEvento = "") => {
    try {
        const qs = new URLSearchParams({
            ...(fecha_init ? { fecha_init } : {}),
            ...(fecha_fin ? { fecha_fin } : {}),
            ...(codigoEvento ? { codigoEvento } : {})
        }).toString()
        let { data } = await axios.get(
            "https://api.t-ickets.com/ms_login/api/v1/comprobantes_pago?" + qs,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ==',
                    'Authorization': `Bearer ${getUsuario()}`
                }
            }
        )
        return data
    } catch (error) {
        return { success: false, message: error?.response?.data?.message || "Error al listar los comprobantes", error }
    }
}

// Trae TODOS los registros de un rango recorriendo el paginado de listarRegistros
// (que topa en size=100 por pagina). Usa hasNext/next_init que ya devuelve el backend.
export const ListarRegistrosTodos = async (ini, fin, { size = 100, maxPaginas = 200 } = {}) => {
    let init = 0
    let todos = []
    let meta = null
    for (let i = 0; i < maxPaginas; i++) {
        let resp
        try {
            const { data } = await axios.post(
                "https://api.t-ickets.com/ms_login/api/v1/listarRegistros?fecha_init=" + ini + "&fecha_fin=" + fin + "&init=" + init + "&size=" + size,
                { "cedula": "" },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                    }
                }
            )
            resp = data
        } catch (error) {
            return { success: false, message: "Error de red al paginar", data: todos, error }
        }
        if (!resp || resp.success === false) break
        meta = resp
        if (Array.isArray(resp.data)) todos = todos.concat(resp.data)
        if (!resp.hasNext || resp.next_init == null) break
        init = resp.next_init
    }
    return { success: true, data: todos, total: meta?.total ?? todos.length }
}

export const listarRegistropanelComprobar = async (parms, estado) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/listarRegistros?estado=" + estado +"&init=0&size=300", parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const listarRegistroPendienteRapido = async (cedula) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/listarRegistros?estado=Pendiente&init=0&size=1", {
            "cedula": cedula
        }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}

/* No generar otra orden si el cliente ya tiene una sin resolver
   (Pendiente o Comprobar) -- se llama justo cuando se confirma el
   cliente de la venta (cedula real, no la de sesion todavia vacia). */
export const verificarCompraPendiente = async (cedula, codigoEvento) => {
    try {
        let { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/compra_pendiente", {
            params: { cedula, ...(codigoEvento ? { codigoEvento } : {}) },
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return { success: false, pendiente: false }
    }
}
export const listarRegistroEvento = async (ini, fin, parms) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login//api/v1/listarRegistros?init=" + ini + "&size=" + fin + "", parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const generarBoleto = async () => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        ...parms,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/generarBoleto", parmspro, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const eliminarRegistro = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    //                                      getDatosUsuariosLocalStorag
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id), 
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/eliminarRegistro",
            { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}

export const anularCompraPendiente = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/anularCompraPendiente",
            { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}

// A diferencia de anularCompraPendiente, esta anula la compra sin importar
// su estado_pago (Pagado, Comprobar, etc). La usa el boton "Anular Compra"
// de la vista de detalle (buscar cedula -> abrir orden).
export const anularCompra = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/anularCompra",
            { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}

export const eliminartiket = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_ticket_usuarios": parms,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/eliminarTicketrepetido",
            {
                ...parmspro
            }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error

    }
}
export const cambiarMetodo = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        ...parms,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/cambiandoMetodoPago", parmspro, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const Comprobanteocr = async (parms) => {
    try {
        let { data } = await axios.post("")
        return data
    } catch (error) {
        return error
    }
}
export const ConsolidarReporte = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        ...parms,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/ConsolidarCompra", parmspro, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (err) {
        return err
    }
}
export const Consiliarcompra = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        ...parms,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/Conciliacion", { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const ActualizaConciliacion = async (parms, id) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }
    try {
        let { data } = await axios.put("https://api.t-ickets.com/ms_login/api/v1/Conciliacion/" + id, { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error

    }

}
export const ComentarioRegistro = async (parms) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/Comentario_registro", parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const updateRegistro = async (parms, id) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        ...parms,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(ids),
    }
    try {
        let { data } = await axios.put("https://api.t-ickets.com/ms_login/api/v1/Comentario_registro/" + id, { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}
export const BuscarTransacion = async (parms) => {
    let ids = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        ...parms
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/BuscarNumeroTransaccion", { ...parms, ...parmspro }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data;
    } catch (error) {
        return error
    }
}
export const ActualizarnumeroTransacion = async (parms) => {
    let id = clienteInfo() != null ? clienteInfo().id : 0
    let idop = clienteInfo() != null ? 0 : getDatosUsuariosLocalStorag().id
    let parmspro = {
        ...parms,
        "id_usuario": parseInt(idop),
        "id_operador": parseInt(id),
    }
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/ActualizarNumeroTransaccion", parmspro, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }

}
export const EstadosCosolidados = async () => {
    try {
        let { data } = await axios.get("https://api.t-ickets.com/ms_login/api/v1/estados_consolidados",
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                }
            }
        )
        return data
    } catch (error) {
        return error
    }

}
export const infoTarjeta = async (parms) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/ms_login/api/v1/info_tarjeta", parms,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
                }
            })
        return data
    } catch (error) {
        return error
    }
}
export const infoabimedia = async (parms) => {
    try {
        let { data } = await axios.get("https://cloud.abitmedia.com/api/payments/status-transaction?access-token=2y-13-gi8r0tx2uwfjj4inqxfc2oyyivnx9wuz1-mt3n2ownqitrb6isc8elfmmdz7rirsh7z94xf2-&token=" + parms)
        return data
    } catch (error) {
        return error
    }
}

// Info de la transaccion en PagoPlux (equivalente a infoabimedia/infoTarjeta pero
// para PagoPlux). "parms" es el id_transaccion, guardado como token_pago en la compra.
export const infoPagoPlux = async (parms) => {
    try {
        let { data } = await axios.get("https://api.t-ickets.com/ms_login/pagoplux/payment/info/" + parms, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return error
    }
}

export const agregarComprobanteAdicional = async (id_registraCompra, url_imagen) => {
    try {
        let { data } = await axios.post("https://api.t-ickets.com/mikroti/Boleteria/comprobantes", {
            id_registraCompra,
            url_imagen
        }, {
            headers: {
                'Content-Type': 'application/json',
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return { estado: false, mensaje: "Error de conexión" }
    }
}

export const listarComprobantesAdicionales = async (id_registraCompra) => {
    try {
        let { data } = await axios.get(`https://api.t-ickets.com/mikroti/Boleteria/comprobantes/${id_registraCompra}`, {
            headers: {
                'authorization-ticket': 'Basic Ym9sZXRlcmlhOmJvbGV0ZXJpYQ=='
            }
        })
        return data
    } catch (error) {
        return { estado: false, data: [] }
    }
}